export default __webpack_public_path__ + "static/media/star_1.edd60516.svg";